// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__f5yR5","children-wrapper":"style_children-wrapper__faUHU","normal":"style_normal__Tnblm","wider":"style_wider__qlzRb"};